const localeStrings = require('./locales/default.json');

const defaultLocale = Object.keys(localeStrings)[0];

export default localeStrings[defaultLocale];



// WEBPACK FOOTER //
// ./src/applicationConfig/localeStrings.js